<template>
　　<div id="app" style="height:100%;">
　　　　<router-view/>     
　　</div>
</template>

<script>
　　export default {
　　　　name: 'app'
　　}
</script>

<style>
html{
  height:100%;
}
#app {
  width:100%;
  height:100%;  
}
</style>
